module.exports = __webpack_public_path__ + "static/media/customerimg.cba48677.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/customerimg.jpg
// module id = 439
// module chunks = 0